<!--  Error Views  -->
<app-module-error class="flex-fill" *ngIf="isNoMetric" [noMetric]="true"></app-module-error>
<app-module-error class="flex-fill" *ngIf="isTooMuchData" [tooMuchData]="true"></app-module-error>
<app-module-error class="flex-fill" *ngIf="isDateRangeTooWideIntraday" [dateRangeTooWideIntraday]="true"></app-module-error>
<app-module-error *ngIf="isNoData" [noData]="true"></app-module-error>
<!--  Content  -->
<div id="legendTooltipInterval" class="legendTooltipInterval" [hidden]="false"></div>
<div class="gridItemChildModule w-100 h-100 align-items-stretch">
    <div *ngIf="dataLoadSuccess && !isNoData && !isNoMetric && !isTooMuchData && !isDateRangeTooWideIntraday" class="d-flex w-100 h-100">
        <div class="d-flex flex-column position-relative" style="flex: 1 1 0px; min-width: 0px;" *ngIf="moduleDisplay !== 'chart'">
            
            <!--  Search  -->
            <div *ngIf="!config.isCxOne" class="search-box live-search w-75 mx-auto my-2" [hidden]="!searchOpen">
                <input #searchBox type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue" [ngModelChangeDebounceTime]="500" (ngModelChangeDebounced)="applyFilter()"
                    placeholder="Search" cvLocalizedText langSection="Common" langKey="Search" />
                <span class="clear-input" role="button" tabindex="0" [hidden]="!(filterValue.length > 0)" (click)="clearFilter()"></span>
            </div>

            <!-- Search cxone -->
            <div *ngIf="config.isCxOne" class="cxone-live-search ml-2 my-2" [hidden]="!searchOpen">
                <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search"
                    (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="500"
                    name="cxoneInput-{{moduleKey}}"></cxone-text-input>
                <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                    <svg class="icon-18 fill-iconDefault cxone-search-wrapper">
                        <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                    </svg>
                </i>
                <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                        <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                    </svg>
                </i>
            </div>

            <!--  Table  -->
            <div *ngIf="gridOptions != null" [hidden]="gridOptions?.columnDefs?.length <= 0" class="flex-fill intervalGridContainer" style="overflow-y: auto;">
                <ag-grid-angular
                    #intervalWidgetGrid 
                    class="ag-theme-balham flex-fill w-100 h-100"
                    [gridOptions]="gridOptions"
                    [aggFuncs]="aggFuncs"
                    [groupDefaultExpanded]="0">
                </ag-grid-angular>
            </div>
            <app-module-error class="flex-fill" *ngIf="isNoData" [noData]="true"></app-module-error>
        </div>
        <div class="view-divider" *ngIf="moduleDisplay === 'dual'"></div>
        <div id="Interval-chart" class="mx-2" *ngIf="moduleDisplay !== 'table'" style="flex: 1 1 0px; min-width: 0px;">
            <div id='IntervalChartArea' [ngClass]="{'horizontalBar': chartType === 'horizontalBar', 'default': chartType !== 'horizontalBar'}">
                <div class="intervalChart">
                    <canvas baseChart *ngIf="chartConfig"
                        [type]="chartConfig.type"
                        [legend]="chartConfig.options.plugins?.legend"
                        [datasets]="chartConfig.data.datasets"
                        [labels]="chartConfig.data.labels"
                        [options]="chartConfig.options"
                        [plugins]="chartConfig.plugins">
                    </canvas>
                </div>
            </div>
        </div>
    </div>
</div>
